<app-environment-ribbon></app-environment-ribbon>
<jhi-info-bar [pageType]="lastPage"></jhi-info-bar>
<div class="header-container d-flex-row">
    <div class="snow-container" *ngIf="showSnow()">
        <div class="inner-snow-container">
            <div class="snow"></div>
        </div>
    </div>
    <div class="header-content d-flex d-flex-row align-items-center" [class.snow-background]="showSnow()">
        <div class="sidenav-toggle-container justify-content-center d-block d-md-none">
            <a mat-icon-button (click)="toggleSidenav()">
                <fa-icon icon="bars"></fa-icon>
            </a>
        </div>
        <div class="logo-container d-flex justify-content-start align-items-center">
            <img class="logo-image" src="/content/images/sos_logo_primary.png" alt="SOS Logo" width="113" height="29">
        </div>
        <div class="d-flex d-none d-md-block justify-content-start align-items-center">
            <span class="title text-nowrap">Part of SOS International</span>
        </div>
            <div class="profile profile-container d-flex justify-content-end align-items-center">
               <jhi-navbar></jhi-navbar>
            </div>
    </div>
</div>
